export default __webpack_public_path__ + "static/media/mongodb.6835c61a.svg";